<template>
  <div class="manual">
    <p>There are 4 status of an order:</p>
    <div>
      <b-badge variant="danger"> Pending: </b-badge>
      <p class="ml-1" style="display: inline-block">Something is missing in the checklist. To procedure forward, Jacky's approval is required.</p>
    </div>
    <div>
      <b-badge variant="success"> Active: </b-badge>
      <p class="ml-1" style="display: inline-block">The task is running.</p>
    </div>
    <div>
      <b-badge variant="warning"> Waiting: </b-badge>
      <p class="ml-1" style="display: inline-block">There is a request for completion.</p>
    </div>
    <div>
      <b-badge variant="secondary"> Completed: </b-badge>
      <p class="ml-1" style="display: inline-block">The order is completed.</p>
    </div>
    <div v-if="this.user.role == 'sales'" class="for-sales">
      <h2>For sales:</h2>
        <b-button>For viewing events</b-button>
        <p>You can click the event button on the navigation bar.</p> 
        <p>You can using static filter to view completed events or older events, or you can search specific events by entering keywords.</p>
        <p>You can view details by clicking the corresponding button.</p>

        <h5>For adding a new event</h5>
        <p>you can click "Add a new row" button then click various types of event which will bring you to the "Add a event" page.</p>
        
        <h5>For adding a Installation order</h5>
        <p>Firstly, you need to tick on the checklist. The unnecessary items should also be ticked. If there is a reason for enfocing to add a new event, a popup will show up and you can click "Enforce" to enforce the creation.
        Then it brings you to the info tab, in which you need to fill all fields for processing the creation.</p>

        <h5>For adding a Small Task order</h5>
        <p>You need to fill all fields for processing the creation. For adding a subtask, click "Add Subtask" button to add a new one.</p>

        <h5>For making comments</h5>
        <p>Once entering the details page, click "Comemnts" tab to view the related comments and click the "Add a comment" button.</p>

        <h5>For downloading files</h5>
        <p>Once entering the files page, click "Files" tab to view the related files, then you can download files by clicking the green arrow.</p>

        <h5>For uploading files</h5>
        <p>Click "Browse" button to select files. You can upload multiple files at a time.</p>

        <h5>For sending an email to the installation staff</h5>
        <p>Click "Email" button to send an email. You can click "Reset" button to clear all the inputs.</p>

        <h5>For edit an event</h5>
        <p>You should click the "Detail" button then click "Edit" button to edit attributes of the event.</p>

        <h5>For export the event for printing</h5>
        <p>When you are in the detail page, click "Export" button to view the page.</p>

        <h5>For approving the completion</h5>
        <p>When you are in the details page, click "Approve" to comfirm the completion.</p>
    </div>
    <div v-if="this.user.role == 'worker'" class="for-workers">
      <h2>For workers:</h2>
        <h5>For viewing events</h5>
        <p>You can click the event button on the navigation bar.</p> 
        <p>You can using static filter to view completed events or older events, or you can search specific events by entering keywords.</p>
        <p>You can view details by clicking the corresponding button.</p>

        <h5>For making comments</h5>
        <p>Once entering the details page, click "Comemnts" tab to view the related comments and click the "Add a comment" button.</p>

        <h5>For downloading files</h5>
        <p>Once entering the files page, click "Files" tab to view the related files, then you can download files by clicking the green arrow.</p>

        <h5>For uploading files</h5>
        <p>Click "Browse" button to select files. You can upload multiple files at a time.</p>

        <h5>For sending an email to the installation staff</h5>
        <p>Click "Email" button to send an email. You can click "Reset" button to clear all the inputs.</p>

        <h5>For export the event for printing</h5>
        <p>When you are in the detail page, click "Export" button to view the page.</p>

        <h5>For marking the events as complete</h5>
        <p>When you are in the details page, firstly, you need to tick all items of the checklsit. Then click "Request for completion" to request the completion.</p>
    </div>
    <div v-if="this.user.role == 'admin'" class="for-admins">
      <h2>For admin:</h2>

      <div class="accordion" role="tablist">

        <b-card>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block class="text-left" v-b-toggle.accordion-0 variant="info">There are 4 status of an order</b-button>
          </b-card-header>
          <b-collapse id="accordion-0" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <p class="ml-1"><b-badge variant="danger"> Pending: </b-badge>Something is missing in the checklist. To procedure forward, Jacky's approval is required.</p>
                <p class="ml-1"><b-badge variant="success"> Active: </b-badge>The task is running.</p>
                <p class="ml-1"><b-badge variant="warning"> Waiting: </b-badge>There is a request for completion.</p>
                <p class="ml-1"><b-badge variant="secondary"> Completed: </b-badge>The order is completed.</p>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block class="text-left" v-b-toggle.accordion-1 variant="info">For viewing events</b-button>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                You can click the event button on the navigation bar.
                You can using static filter to view completed events or older events, or you can search specific events by entering keywords.
                You can view details by clicking the corresponding button.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block class="text-left" v-b-toggle.accordion-2 variant="info">For making comments</b-button>
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                Once entering the details page, click "Comemnts" tab to view the related comments and click the "Add a comment" button.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block class="text-left" v-b-toggle.accordion-3 variant="info">For downloading files</b-button>
          </b-card-header>
          <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                Once entering the files page, click "Files" tab to view the related files, then you can download files by clicking the green arrow.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block class="text-left" v-b-toggle.accordion-4 variant="info">For uploading files</b-button>
          </b-card-header>
          <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                Click "Browse" button to select files. You can upload multiple files at a time.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        
        <b-card>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block class="text-left" v-b-toggle.accordion-5 variant="info">For sending an email to staffs</b-button>
          </b-card-header>
          <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                Click "Email" button to send an email. You can click "Reset" button to clear all the inputs.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block class="text-left" v-b-toggle.accordion-6 variant="info">For export the event for printing</b-button>
          </b-card-header>
          <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                When you are in the detail page, click "Export" button to view the page.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block class="text-left" v-b-toggle.accordion-6 variant="info">For allowing the events to be enforced</b-button>
          </b-card-header>
          <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                When you are in the details page, click "Allow" button.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Manual',
  props: {
    user: Object,
  }
}
</script>

<style>
.manual p {
  margin: 0;
}
</style>
